module.exports = __webpack_public_path__ + "assets/img/translation-app-2.a2aaa6ac.png";